import mqtt from 'mqtt'

export default class MqttService {
  constructor (config, handlers = {}) {
    this.config = { ...config }
    this.handlers = handlers
    this.client = null
  }

  get baseTopic () {
    return `office/camera/${this.config.deviceId}`
  }

  get connected () {
    return Boolean(this.client && this.client.connected)
  }

  connect () {
    this.disconnect()
    this.client = mqtt.connect(this.config.mqttUrl, {
      clientId: `office_cam_web_${Date.now()}_${Math.random().toString(16).slice(2, 8)}`,
      username: this.config.mqttUsername,
      password: this.config.mqttPassword,
      keepalive: 30,
      connectTimeout: 8000,
      reconnectPeriod: 3000,
      clean: true
    })

    this.client.on('connect', () => {
      this.client.subscribe(`${this.baseTopic}/#`, { qos: 0 }, error => {
        if (error) this.emit('onError', error)
        else this.emit('onConnect')
      })
    })
    this.client.on('reconnect', () => this.emit('onReconnect'))
    this.client.on('offline', () => this.emit('onOffline'))
    this.client.on('close', () => this.emit('onOffline'))
    this.client.on('error', error => this.emit('onError', error))
    this.client.on('message', (topic, payload) => this.emit('onMessage', topic, payload))
  }

  disconnect () {
    if (this.client) this.client.end(true)
    this.client = null
  }

  publishCommand (command, value, callback) {
    if (!this.connected) {
      if (callback) callback(new Error('MQTT 尚未连接'))
      return
    }
    this.client.publish(`${this.baseTopic}/command/${command}`, String(value), { qos: 1, retain: false }, callback)
  }

  emit (name, ...args) {
    if (this.handlers[name]) this.handlers[name](...args)
  }
}
